export default "__VITE_ASSET__857d36f2__"